export default __webpack_public_path__ + "static/media/fendt-828-vario.83371137.png";